import { render, staticRenderFns } from "./CategoryComponent.vue?vue&type=template&id=30019bd0&scoped=true&"
import script from "./CategoryComponent.vue?vue&type=script&lang=js&"
export * from "./CategoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./CategoryComponent.vue?vue&type=style&index=0&id=30019bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/katonobo/Documents/Web App/dream-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30019bd0",
  null
  
)

export default component.exports